import { AbstractAgent, Middleware, RunAgentInput } from "@ag-ui/client";
import {
  FailAiAssistantRun,
  FinishAiAssistantRun,
  ReceiveDraftConfirmation
} from "../action-types";
import { CaseDraftPayload, CaseDraftSnapShot } from "../types";

const extractConfirmedDraft = (event: { type: string, snapshot?: CaseDraftSnapShot }): CaseDraftPayload | undefined => {
  if (!event?.snapshot?.UserConfirmed) {
    return undefined;
  }
  return event?.snapshot?.CaseDraft;
};

export class AiAssistantActionMiddleware extends Middleware {
  constructor(private dispatch: (action: any) => void) {
    super();
  }

  run(input: RunAgentInput, next: AbstractAgent) {
    const observable = this.runNext(input, next);
    const ObservableConstructor = (observable as any).constructor;
    
    return new ObservableConstructor((observer: any) => {
      const subscription = observable.subscribe({
        next: (event: any) => {
          if (event.type === 'StateSnapshotEvent') {
            const draft = extractConfirmedDraft(event);
            if (draft) {
              this.dispatch(new ReceiveDraftConfirmation(draft));
            }
          }
          
          observer.next(event);
        },
        error: (err: any) => {
          const message = err?.message || '';
          this.dispatch(new FailAiAssistantRun(message));
          observer.error(err);
        },
        complete: () => {
          this.dispatch(new FinishAiAssistantRun());
          observer.complete();
        }
      });

      return () => subscription.unsubscribe();
    });
  }
}
